import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportListaDisciplinasUseCase } from "../../../presentation/useCases/read/get_report_lista_disciplinas_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";

import dayjs from "dayjs";


export class GetReportListaDisciplinasUseCase implements IGetReportListaDisciplinasUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportListaDisciplinas(
    requiredMimeType: ReportMimeType | null,  IdProjeto: number
  ): Promise<ReportData> {
    const response = await this.repository.getReportListaDisciplinas(requiredMimeType, IdProjeto);

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `lista_disciplinas_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }
}

